/**
 * Global Search API Types & Validation
 */

import { z } from '@ufc/core'
import type { SearchResponse } from '../domain/types'

export const searchResultSchema = z.object({
  type: z.enum([
    'order',
    'sales-order',
    'shipment',
    'location',
    'visitor',
    'visit',
    'gate',
    'zone',
    'driver',
    'asset',
    'tenant',
    'invoice',
    'product',
  ]),
  id: z.number(),
  documentId: z.string().optional(),
  title: z.string(),
  subtitle: z.string(),
  status: z.string().optional(),
  metadata: z.record(z.string(), z.unknown()).optional(),
})

export const searchResponseSchema = z.object({
  results: z.array(searchResultSchema),
  total: z.number(),
  query: z.string(),
})

export const portalTypeSchema = z.enum(['customer', 'gate', 'admin'])

export function validateSearchResponse(data: unknown): SearchResponse {
  return searchResponseSchema.parse(data)
}

export const GLOBAL_SEARCH_ENDPOINTS = {
  SEARCH: '/api/global-search',
} as const
